import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from "./Login";
// import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import EmailVerification from "./emailVerification";
import CompanyDataFirstPage from "../MyApplicationPage/CompanyDataFirstPage";

const AuthPageRoute = () => {
  return (
    <Switch>
      <Route path="/auth/login" component={Login} />
      <Route path="/auth/forgot-password" component={ForgotPassword} />
      <Route path="/auth/reset-password" component={ResetPassword} />
      <Route exact path="/auth/email_verification/:id" component={EmailVerification} />
      <Route exact path="/auth/company-data-first" component={CompanyDataFirstPage} />
      {/* <Route path="/auth/register" component={Register} /> */}
    </Switch>
  );
};

export default AuthPageRoute;
